import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ToastProvider as HeroToastProvider, addToast, closeToast, closeAll } from '@heroui/react';
export const ToastProvider = ({ children, ...props }) => {
    return (_jsxs(_Fragment, { children: [_jsx(HeroToastProvider, { ...props }), children] }));
};
export const useToastNotification = () => {
    const showToast = (options) => {
        return addToast(options);
    };
    const hideToast = (id) => {
        closeToast(id);
    };
    const hideAllToasts = () => {
        closeAll();
    };
    return {
        showToast,
        hideToast,
        hideAllToasts,
        addToast,
        closeToast,
        closeAll
    };
};
export { addToast, closeToast, closeAll };
export default ToastProvider;
//# sourceMappingURL=Toast.js.map